import YearRange from './YearRange.vue'

export default YearRange
